module BusinessLogic

let getHexColor (r, g, b) =
  let get (num: float) =
    match num.ToString("x") with
    | v when v.Length = 1 -> "0" + v
    | v -> v

  $"#%s{get r}%s{get g}%s{get b}"

let getColor (minColorR, minColorG, minColorB) (maxColorR, maxColorG, maxColorB) minNum maxNum (num: float) =

  let percentage = (num - minNum) / (maxNum - minNum)

  let getColorValue minColor maxColor =
    minColor + (maxColor - minColor) * percentage

  let r = getColorValue minColorR maxColorR
  let g = getColorValue minColorG maxColorG
  let b = getColorValue minColorB maxColorB
  getHexColor (r, g, b)

let gpPercentColor value =
  let at8 = 5.0, 156.0, 33.0
  let at3 = 89.0, 179.0, 66.0
  let at0 = 255.0, 255.0, 0.0
  let atMin3 = 255.0, 183.0, 0.0
  let atMin8 = 255.0, 0.0, 0.0
  let atMin15 = 122.0, 2.0, 2.0

  match value * 100.0 with
  | v when v >= 8.0 -> getHexColor at8
  | v when v >= 3.0 -> getColor at3 at8 3.0 8.0 v
  | v when v >= 0.0 -> getColor at0 at3 0.0 3.0 v
  | v when v >= -3.0 -> getColor atMin3 at0 -3.0 0.0 v
  | v when v >= -8.0 -> getColor atMin8 atMin3 -8.0 -3.0 v
  | v when v >= -15.0 -> getColor atMin15 atMin8 -15.0 -8.0 v
  | v when v < -15.0 -> getHexColor atMin15
  | _ -> invalidOp "Should never happen"